import {
  Box,
  Grid,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

export default function SkeletonListarOcs() {
  return (
    <Grid container spacing={3} justifyContent="center" size={{ xs: 12 }}>
      <Grid size={{ xs: 12 }}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box sx={{ width: "100%", overflowX: "auto" }}>
            <Table>
              <TableHead>
                <TableRow>
                  {["Ordem", "Fornecedor", "Valor", "Status"].map((col, i) => (
                    <TableCell key={i}>
                      <Skeleton variant="text" width={80} height={20} />
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.from({ length: 8 }).map((_, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <Skeleton variant="text" width={90} height={24} />
                      <Skeleton variant="text" width={120} height={16} />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="text" width="80%" height={24} />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" width={60} height={24} />
                    </TableCell>
                    <TableCell>
                      <Skeleton
                        variant="rounded"
                        width={80}
                        height={28}
                        sx={{ borderRadius: 5 }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>

          <Box mt={3} display="flex" justifyContent="flex-end">
            <Stack direction="row" spacing={2}>
              <Skeleton variant="rectangular" width={80} height={30} />
              <Skeleton variant="rectangular" width={80} height={30} />
            </Stack>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
}
